import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6939d675cbbd90001310b69e_1785437567662_62bc800e/lone_star_local/src/app/not-found.tsx");
